import { Navigate, useParams } from 'react-router-dom'

export function LegacyConversationEngineRedirect() {
  const { productId = '' } = useParams()
  const target = productId ? `/admin/brain?tab=products&productId=${encodeURIComponent(productId)}` : '/admin/brain?tab=products'
  return <Navigate to={target} replace />
}
